import React,  { useEffect,useState} from 'react'
import { Button, Row, Col, Table } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { listOuterPosts } from '../actions/mediaActions'
import OuterPost from '../components/OuterPost'
import Loader from '../components/Loader'
import Message from '../components/Message'
import SearchBox from '../components/SearchBox'
import Paginate from '../components/Paginate'
import Masonry from 'react-masonry-css'
import AOS from "aos";
import AnimatedPage from '../components/AnimatedPage'
import { Helmet } from 'react-helmet-async'

function PublicForumScreen({ history }) {

  const dispatch = useDispatch()
  const outerPostList = useSelector(state => state.outerPostList)
  const {error, loading, outerposts, page, pages} = outerPostList

  let keyword = history.location.search

  useEffect(() => {
    dispatch(listOuterPosts(keyword));
    AOS.init();
    AOS.refresh();
  }, [dispatch, keyword])

  const breakpointColumnsObj = {
    default: 5,
    1200: 4,
    900: 3,
    600: 2,
  
  };

  return (
    <AnimatedPage>
    <div>
      <Helmet>
        <title>Forum pubblico – RayquazaITA</title>
        <meta name="description" content="Community RayquazaITA: scambi, discussioni e post pubblici sul mondo Pokémon TCG Pocket." />
      </Helmet>

 <Link to={`/createOutPost`}>    
    <Button className='my-3 '>
    <i className='fas fa-plus'></i> Crea post
    </Button>
 </Link>

    <SearchBox basePath="/forum"/>

 {loading ? <Loader/>
          : error ? <Message variant='danger' >{error}</Message>
                    
            :
            <div>
            <Masonry
            breakpointCols={breakpointColumnsObj}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            {outerposts.map(outerpost => ( 
                <div data-aos="fade-up" key={outerpost._id} className="masonry-item">
                  <OuterPost outerpost={outerpost}/>
                </div> )
                )}
          </Masonry>
          <Paginate page={page} pages={pages} keyword={keyword} basePath="/forum"/>
          </div>
          }
    
    </div>
    </AnimatedPage>
  )
}

export default PublicForumScreen